'use client';
import { createContext, useContext } from 'react';
import { omitUndefined } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultContextValue = {
    maxColItems: 6
};
const FooterNavigationContext = /*#__PURE__*/ createContext(defaultContextValue);
const FooterNavigationProvider = FooterNavigationContext.Provider;
const useFooterNavigationContext = ()=>useContext(FooterNavigationContext);
const extractContextProps = (_param)=>{
    var { maxColItems, onItemClick, onCategoryTitleClick } = _param, others = _object_without_properties_loose(_param, [
        "maxColItems",
        "onItemClick",
        "onCategoryTitleClick"
    ]);
    return [
        _extends({}, defaultContextValue, omitUndefined({
            maxColItems,
            onItemClick,
            onCategoryTitleClick
        })),
        others
    ];
};

export { FooterNavigationProvider, defaultContextValue, extractContextProps, useFooterNavigationContext };
//# sourceMappingURL=FooterNavigation.context.js.map
